import React, { useEffect , useState} from "react";
import logo from "../assets/pos.png";
import user from "../assets/user.png";
import "../style/navbar.css"
import { useNavigate } from 'react-router-dom';

function Navbar() {

  const navigate = useNavigate();

  const [imgSrc, setImgSrc] = useState(user);

  const [showMenu, setShowMenu] = useState(false);

  // const [notifyCount, setNotifyCount] = useState(0);

  const logout = () => {
      localStorage.removeItem('empDetails');
      navigate("/");
  }

   const forgetPassword = () => {
      localStorage.removeItem('empDetails');
      navigate("/forgetpassword");
  }

   
  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}"); // parse user object

  // const imageUrl = `https://psmport.pothysswarnamahalapp.com/AllStaffsImage/${empDetails.employee_code}.jpg`

  useEffect(() => {

    if(!empDetails.emp_name){
      navigate("/");
    }

    if (empDetails?.employee_code)
       {
         const imageUrl = `https://psmport.pothysswarnamahalapp.com/AllStaffsImage/${empDetails.employee_code}.jpg`; 
         setImgSrc(imageUrl); 
      }

  },[])

  return (
    <nav className="navbar navbar-expand-lg navbar-white bg-whit shadow" style={{
      background:'#2B7CD3',
        // background:"#3F53B6",
        // position: "sticky",
        top: 0,
        zIndex: 1050
      }}>


      <div className="container-fluid position-relative mx-lg-3 mx-1">

          {/* LEFT - toggle */}
          <div className="position-absolute start-0">
            <button className="btn "   
                    data-bs-toggle="offcanvas"
                    data-bs-target="#sidebarMenu"
                >
              <i className="bi bi-list menuicon text-white"></i>
            </button>
          </div>

          {/* CENTER - LOGO */}
          <div className="text-center w-100">
            <img src={logo} className="navlogo" alt="logo" onClick={() => navigate("/Dashboard")} style={{cursor:"pointer"}}/>
          </div>

          {/* RIGHT - USER */}
          {/* <div className="position-absolute end-0 d-flex flex-column align-items-center text-white " onClick={() => logout()}>          
            <img src={imgSrc} className="userImage"></img>
            <label className="userName fw-bold">{empDetails?.emp_name}</label>            
          </div> */}

          <div
            className="position-absolute end-0 text-white profile-section d-flex align-items-center"
            onClick={() => setShowMenu(!showMenu)}
          >
{/* <i class="bi bi-bell-fill text-light fs-3 me-lg-3 me-2"></i> */}
            <div className="d-flex flex-column align-items-center">
              {/* <img src={imgSrc} className="userImage" alt="user" /> */}
              <img
                src={imgSrc}
                className="userImage"
                alt="user"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = user;
                }}
              />

              <label className="userName fw-bold">
                {empDetails?.emp_name}
              </label>
            </div>

            {showMenu && (
              <div className="profile-dropdown">

                <button
                  className="dropdown-btn"
                  // onClick={() => navigate("/forgetpassword")}
                   onClick={forgetPassword}
                >
                  Forgot Password
                </button>

                <button
                  className="dropdown-btn logout-btn text-danger"
                  onClick={logout}
                >
                  Logout
                </button>

              </div>
            )}
          </div>


        </div>

    </nav>
  );
}

export default Navbar;